import { ApprovalQueueList, useApprovalQueue, type ApprovalItem } from './ApprovalQueue'

interface Props {
  items: ApprovalItem[]
}

// Card compacto "Precisa de você" no topo da landing do agente (SZ-1599/C.4):
// as mesmas ações da home (componente reutilizado), recarregando apenas a
// prop `pending_approvals` da página Show. Só renderiza com pendências — sem
// zero-state, para não ocupar a landing quando não há nada a resolver.
// Mesmo padrão visual da home: label 10.5/650 uppercase + contador pill
// warn-soft (protótipo).
export default function PendingApprovalsCard({ items }: Props) {
  const queue = useApprovalQueue(items, 'pending_approvals')

  if (queue.visibleItems.length === 0) return null

  return (
    <section aria-label="Precisa de você" data-testid="worker-pending-approvals" className="space-y-2">
      <h2 className="flex items-center gap-2 text-[10.5px] font-semibold uppercase tracking-[0.1em] text-faint-foreground">
        Precisa de você
        <span className="rounded-full bg-warning/13 px-2 py-px text-[10.5px] text-warning dark:bg-warning/15">
          {queue.visibleItems.length}
        </span>
      </h2>
      <ApprovalQueueList queue={queue} showWorkerName={false} />
    </section>
  )
}
